class SortBy extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      select: this.querySelector('[data-sort-by-el="select"]'),
    }

    this._boundHandlers = {
      handleInitialized: () => this.render(),
      handleChange: e => this.handleChange(e),
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.elements.select?.addEventListener(
      'change',
      this._boundHandlers.handleChange,
    )
  }

  disconnectedCallback () {
    window.theme.tagalys.results.eventBus.unsubscribe(
      'results:api:fetched:success',
      this._boundHandlers.handleInitialized,
    )
    this.elements.select?.removeEventListener(
      'change',
      this._boundHandlers.handleChange,
    )
  }

  subscribeToEvents () {
    window.theme.tagalys.results.eventBus.subscribe(
      'results:api:fetched:success',
      this._boundHandlers.handleInitialized,
    )
  }

  handleChange (e) {
    window.theme.tagalys.results.SDK.helpers.applySortOption(e.target.value)
    window.theme.tagalys.results.eventBus.publish('results:ui:sort:changed')
  }

  render () {
    if (!this.elements.select) return

    const sortOptions =
      window.theme.tagalys.results.SDK.helpers.getSortOptions() || []

    this.elements.select.innerHTML = sortOptions
      .map(option => {
        const value = String(option.id ?? '').replace(/"/g, '&quot;')
        const label = String(option.label ?? '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
        return `
          <option value="${value}" ${option.selected ? 'selected' : ''}>
            ${label}
          </option>
        `
      })
      .join('')
  }
}

if (!customElements.get('sort-by')) {
  customElements.define('sort-by', SortBy)
}
